import React, { FC } from 'react'
import { Heading, Text } from '@rolex-ui'
import { Box, theme } from '@gassan-ui'
import * as S from './elements'
import CtaButtons from '../RetailerCtaButtons'
import { useLocalization } from '@components/Localization'
import { RolexStore } from '@lib/kontent/models/RolexStore'
import { rem } from 'polished'

type Props = {
  isVisible: boolean
  onClose: () => void
  retailer: RolexStore
}

const ShopDetails: FC<Props> = ({ isVisible, onClose, retailer }) => {
  const { messages } = useLocalization()
  return (
    <S.Wrap isShown={isVisible}>
      <S.CloseWindow onClick={onClose} />
      <S.ContentWrap>
        <Box
          position="relative"
          height="100%"
          width="100%"
          textAlign={['center', 'center', 'left']}
        >
          {retailer && (
            <>
              <S.ImgWrap>
                {retailer.store_image.value[0] && (
                  <img
                    src={retailer.store_image.value[0].url}
                    alt={retailer.store_image.value[0].description}
                    loading="lazy"
                  />
                )}
              </S.ImgWrap>
              <Box pt="2.5rem" pb="1rem" px={rem(20)} textAlign="center" position="relative">
                <S.CloseButton onClick={onClose}>
                  <svg height="11" width="11" viewBox="0 0 11 11" fill="currentColor">
                    <path d="m6.9 5.5 4.1 4.1-1.4 1.4-4.1-4.1-4.1 4.1-1.4-1.4 4.1-4.1-4.1-4.1 1.4-1.4 4.1 4.1 4.1-4.1 1.4 1.4z" />
                  </svg>
                </S.CloseButton>
                <Heading variant="smallSubtitle" as="h3" color={theme.rolex.colors.primary}>
                  {messages.rolex.contact.officialRetailer}
                </Heading>
                <Heading variant="gridTitle" as="h2" mb={rem(10)}>
                  {retailer.name.value}
                </Heading>
                <Text variant="smallDescription" mb={['1.25rem', '2rem']}>
                  {retailer.address_details.value}
                </Text>
                <CtaButtons
                  phoneNumber={retailer.phone_number.value}
                  directionsUrl={`https://maps.google.com?saddr=Current+Location&daddr=${retailer.latitude.value},${retailer.longitude.value}`}
                  detailSlug={retailer.url_slug.value}
                />
              </Box>
            </>
          )}
        </Box>
      </S.ContentWrap>
    </S.Wrap>
  )
}

export default ShopDetails
